import { mapGetters } from "vuex";
import config from "@/config";
import axios from "axios";
import moment from "moment";
export default {
  props: ["value", "pageid"],
  data: function() {
    return {
      isInputVoucherCode: false,
      hasVoucherCode: false,
      loading: false,
      promocode: null,
      allPromoCode: [],
      sessiontoken: null,
      userid: null,
      hasError: false,
      discount: null,
      total: null,
      promotion: null,
      dialog: false,
    };
  },
  computed: {
    ...mapGetters({
      cart: "getCart",
      loadingPageProfile: "getLoadingPageProfile",
      pageProfile: "getPageProfile",
      theme: "getTheme",
    }),
    currencySign: function() {
      if (this.pageProfile && this.pageProfile.pageid == "402026927063253") {
        return "$";
      } else if (this.pageProfile.pageid == "751241271893504") {
        return "K";
      } else {
        return "฿";
      }
    },
  },
  mounted: function() {
    var vm = this;
    if (vm.$route.query.sessiontoken) {
      vm.sessiontoken = vm.$route.query.sessiontoken;
    }
    if (vm.$route.query.userid) {
      vm.userid = vm.$route.query.userid;
      vm.getPromotionCodeAvailable();
    }
    if (vm.value && vm.value != "") {
      vm.promocode = vm.value;
      vm.getCalculateWithPromocode();
    }
  },
  methods: {
    dateFormat(dateTime) {
      return dateTime !== null ? moment(dateTime).format("DD/MM/YYYY - hh.mm") : "-";
    },
    selectPromoCode(code) {
      this.promocode = code;
      this.dialog = false;
      this.onCheckVoucher();
    },
    async getPromotionCodeAvailable() {
      try {
        var response = await axios.get(
          `${config.getConfig("serverUrl")}get_promotion_code_available`,
          {
            params: { pageid: this.pageProfile.pageid, userid: this.userid },
          }
        );
        this.allPromoCode = response.data.data;
      } catch (error) {
        this.allPromoCode = [];
      }
    },
    onCheckVoucher: function() {
      this.getCalculateWithPromocode();
    },
    getCalculateWithPromocode: async function() {
      let vm = this;
      if (!vm.cart || vm.cart.length == 0 || vm.isCartOutOfStock) {
        return false;
      }
      vm.loading = true;
      let data = { promocode: vm.promocode.toUpperCase(), cartarray: [] };
      console.log(vm.cart);
      if (vm.cart) {
        data.cartarray = vm.cart.map(function(val) {
          return { pid: val.id, qty: val.quantity, option: val.option };
        });
      }
      let url =
        config.getConfig("serverUrl") + "calculatewithpromocode?pageid=" + vm.pageProfile.pageid;
      if (
        vm.userid != null &&
        vm.sessiontoken != null &&
        vm.userid != "" &&
        vm.sessiontoken != ""
      ) {
        url += "&userid=" + vm.userid + "&sessiontoken=" + vm.sessiontoken;
      }
      let response = await axios.post(url, data);
      if (response.data.responsecode == 200) {
        let result = response.data;
        if (result.promoobj && result.promoobj.length > 0) {
          vm.$emit("onUpdateTotal", {
            ...result,
            onUpdate: function() {
              vm.onCheckVoucher();
            },
          });
          vm.discount = result.discount;
          vm.total = result.total;
          vm.promotion = result;
          vm.hasVoucherCode = true;
          vm.isInputVoucherCode = false;
        } else {
          vm.$emit("onUpdateTotal", null);
          vm.discount = null;
          vm.total = null;
          vm.hasVoucherCode = false;
        }
        vm.loading = false;
      } else {
        vm.loading = false;
        vm.discount = null;
        vm.total = null;
        vm.hasVoucherCode = false;
        vm.$emit("onUpdateTotal", null);
        vm.hasError = true;
      }
    },
    async clearpromocodeincart() {
      //     POST /clearpromocodeincart
      // qs : userid,pageid ,sessiontoken

      this.loading = true;
      let data = {
        userid: this.userid,
        pageid: this.pageProfile.pageid,
        sessiontoken: this.sessiontoken,
      };

      let response = await axios.post(
        config.getConfig("serverUrl") + "clearpromocodeincart",
        {},
        { params: data }
      );

      if (response.status == 200 && response.data.responsecode == 200) {
        this.hasVoucherCode = false;
        this.promocode = null;
        this.promotion = null;
        this.discount = null;
        this.total = null;
        this.$emit("onUpdateTotal", null);
      }
      this.loading = false;
    },
  },
  watch: {
    value: function(newVal, oldVal) {
      var vm = this;

      if (newVal != oldVal) {
        vm.promocode = newVal;
        vm.getCalculateWithPromocode();
      }
    },
  },
};
